import Typography from '@mui/material/Typography';

function BuildVersion() {
  const version = process.env.REACT_APP_VERSION || 'N/A';
  return (
    <Typography
      variant='caption'
      color='text.secondary'
      data-testid='build-version'
      sx={{
        position: 'fixed',
        bottom: 8,
        right: 16,
        zIndex: 900,
        pointerEvents: 'none',
        userSelect: 'none',
        opacity: 0.6,
      }}
    >
      {`v${version}`}
    </Typography>
  );
}

export default BuildVersion;
